export const isSearchBarEnabled = process.env.REACT_APP_DISABLE_SEARCH_BAR !=="true"